
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tuotteet/tuote-naytto/[slug]",
      function () {
        return require("private-next-pages/tuotteet/tuote-naytto/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tuotteet/tuote-naytto/[slug]"])
      });
    }
  